import { cn } from "@/lib/utils";
import { dateTimeLines } from "@/lib/format";
import { useTranslation } from "react-i18next";

/****************
 * The date-time shown in every table: month and day on top, year and time
 * below, centred (Guillaume, 2026-10-01). See dateTimeLines in lib/format.
 *
 * Neither line can wrap, so a narrow column cannot break the date at a place
 * of its own choosing. The full text is the tooltip.
 ****************/
export function DateTimeCell({
  value,
  seconds,
  className,
  before,
}: {
  value: Date | number | string | null | undefined;
  /** No exact time, but the position was open by this date (entry_time_before, review #90). */
  before?: Date | number | string | null;
  /** Orders tables show seconds; everything else does not. */
  seconds?: boolean;
  className?: string;
}) {
  const { t } = useTranslation("common");
  const lines = dateTimeLines(value, { seconds });
  const bound = !lines && before ? dateTimeLines(before, { seconds }) : null;
  if (bound) {
    return (
      <span
        title={t("time.before.info")}
        className={cn("inline-flex flex-col items-center text-center leading-tight whitespace-nowrap tabular-nums cursor-help", className)}
      >
        <span>{t("time.before", { date: bound[0] })}</span>
        <span className="text-[11px] text-muted-foreground underline decoration-dotted">{bound[1]}</span>
      </span>
    );
  }
  if (!lines) return <span className="text-muted-foreground">—</span>;
  return (
    <span
      title={`${lines[0]}, ${lines[1]}`}
      className={cn("inline-flex flex-col items-center text-center leading-tight whitespace-nowrap tabular-nums", className)}
    >
      <span>{lines[0]}</span>
      <span className="text-[11px] text-muted-foreground">{lines[1]}</span>
    </span>
  );
}
